import { REQUEST_ACCOUNTSUMMARY, RECEIVE_ACCOUNTSUMMARY, IAccountSummaryState, AccountSummaryType } from "./types";
import { RECEIVE_RECENTTRANSACTION, REQUEST_RECENTTRANSACTION, IRecentTransactionState, RecentTransactionType } from "./types";
import { REQUEST_CHARTDATA, RECEIVE_CHARTDATA, ITransactionChartState, TransactionChartType } from "./types";

const initialSummaryState: IAccountSummaryState = {
    accountSummaryData: { data: [], "month-alerts": 0, "month-transactions": 0, "total-accounts": -1 },
    isLoading: false,
};

export function accountSummaryReducer(state = initialSummaryState, action: AccountSummaryType): IAccountSummaryState {
    if (state === undefined) {
        return initialSummaryState;
    }

    switch (action.type) {
        case REQUEST_ACCOUNTSUMMARY:
            return {
                isLoading: true,
                accountSummaryData: state.accountSummaryData,
            };
        case RECEIVE_ACCOUNTSUMMARY:
            return {
                isLoading: false,
                accountSummaryData: action.accountSummaryData,
            };
        default:
            return state;
    }
}

const initialRecentTransactionState: IRecentTransactionState = {
    recentTransactionData: { data: [], metadata: { "num-total": "0" } },
    isLoading: false,
};
export function transactionActivityReducer(state = initialRecentTransactionState, action: RecentTransactionType): IRecentTransactionState {
    if (state === undefined) {
        return initialRecentTransactionState;
    }

    switch (action.type) {
        case REQUEST_RECENTTRANSACTION:
            return {
                isLoading: true,
                recentTransactionData: state.recentTransactionData,
            };
        case RECEIVE_RECENTTRANSACTION:
            return {
                isLoading: false,
                recentTransactionData: action.recentTransactionData,
            };
        default:
            return state;
    }
}

const initialTransactionChartState: ITransactionChartState = {
    transactionChartData: {
        data: [],
        "transaction-month-dollar-value": 0,
        "transaction-scanned-month": 0,
        "transaction-scanned-week": 0,
        "transaction-week-dollar-value": 0,
        "transactions-alerted-month": 0,
        "transactions-alerted-week": 0,
    },
    isLoading: false,
};
export function transactionChartReducer(state = initialTransactionChartState, action: TransactionChartType): ITransactionChartState {
    if (state === undefined) {
        return initialTransactionChartState;
    }

    switch (action.type) {
        case REQUEST_CHARTDATA:
            return {
                isLoading: true,
                transactionChartData: state.transactionChartData,
            };
        case RECEIVE_CHARTDATA:
            return {
                isLoading: false,
                transactionChartData: action.transactionChartData,
            };
        default:
            return state;
    }
}
